module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAOFJREFUOE9jZKAyYKSyeQxD3MDlMVq2fxkZoriZ2SoDF1z4QEzw4PXy0njtmv///jczMDDsuf34mmfjAYY/hAzFa+CqUC22XxyM+xkY/lsxMvyfGr34eg5FBoI0L47RlGRkYDzDwMggxcDImB2z6Oo0fIYSFcvL4jQs//9n2v+fgYGJkfG/V/Si63twGUqUgSDNS2O00v4zMsxkYGB4/5fxn0X8ohu3sBk6MAZS1ctUjRSqJ5ulcdq1////b6Jawl6RoGnx5y9T+G/mr42JCx5QnvUI5QqKkg2xhhOdDgfMQABjs2MVSO/DbAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/new-home/hot-rank-arrow.png
// module id = UQDP
// module chunks = 52